import Vue from 'vue'

Vue.prototype.$currency = {
  code: 'RON',
  name: 'RON'
}
